import { render } from "./BasketSummary.vue?vue&type=template&id=0263d560&scoped=true"
import script from "./BasketSummary.vue?vue&type=script&lang=js"
export * from "./BasketSummary.vue?vue&type=script&lang=js"

import "./BasketSummary.vue?vue&type=style&index=0&id=0263d560&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0263d560"]])

export default __exports__